<template>
  <div class="carousel-box">
    <el-carousel :height="tableHeight">
      <el-carousel-item v-for="(item,i) in carouselList"
                        :key="i">
        <img v-lazy="item">
      </el-carousel-item>
      <div class="carouselmain">
        <h4>会员管家，助您实现会员全家「购」</h4>
        <h5>“硬件-数据-服务”一体化，助力机构数字化健康新零售</h5>
        <div class="down-box">
          <div class="down-item">
            <div @click="handleDownLoad"
                 class="PCdownload">
              <img src="../../static/assets/Fill 1.png">
              立即下载
            </div>
            <div @click="handleDownLoad"
                 class="PCdownloads">PC端下载
            </div>
            <p class="text">(只能在Windows系统上运行)</p>
          </div>
          <div class="down-item">
            <img src="../../static/assets/huawei.png"
                 class="huawei-img">
            <p class="PCdownloads">华为认证证书<a class="read"
                                            @click="readDialog = true">查阅 ></a></p>
          </div>
          <div class="down-item">
            <a @click.prevent="dialogVisible = true"
               class="PCdownload drive-btn">
              <img src="../../static/assets/Fill 1.png">
              驱动下载
            </a>
          </div>
        </div>
      </div>
    </el-carousel>
    <el-dialog title="驱动程序下载"
               :visible.sync="dialogVisible"
               width="30%"
               @close="dialogVisible = false">
      <ul class="down-list">
        <li>
          <span>读卡器驱动</span>
          <a href="https://filehw.tianxia120.com/file/PL2303_Prolific_DriverInstaller_v110.exe"
             download>立即下载</a>
        </li>
        <li>
          <span>打印驱动</span>
          <a href="https://filehw.tianxia120.com/file/printDriver.exe"
             download>立即下载</a>
        </li>
        <li>
          <span>Getein208</span>
          <a href="https://filehw.tianxia120.com/file/CP210x_Windows_Drivers.zip"
             download>立即下载</a>
        </li>
      </ul>
      <span slot="footer"
            class="dialog-footer">
      </span>
    </el-dialog>
    <el-dialog title="华为认证证书"
               :visible.sync="readDialog"
               width="30%"
               @close="readDialog = false">
      <img src="../../static/assets/huawei-book.png"
           alt="华为认证证书"
           class="huawei-book">
    </el-dialog>
    <el-dialog title="文件下载中"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :modal="false"
               :visible.sync="showProgress">
      <div style="height: 120px;width: 100%;padding-top: 60px">

        <el-progress style="margin-bottom: 60px" :percentage="progressBarPercentage" :text-inside="true"
                     :stroke-width="26"/>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {downlodePc} from '../api/user'
import md5 from 'js-md5'
import ajax from "../util/ajax";
import axios from "axios";

export default {
  name: "carousel",
  data() {
    return {
      dialogVisible: false,
      readDialog: false,
      showProgress: false,
      carouselList: ['http://file.tianxia120.com/member_banner003.png', 'http://file.tianxia120.com/member_banner004.png', 'http://file.tianxia120.com/member_008.jpg'],
      scancode: '',
      screenWeight: document.body.clientWidth,
      tableHeight: '',
      // baseUrl: 'http://192.168.0.86:8080/cat/file/downloadFile?url=',//测试
      baseUrl: 'https://app.tianxia120.com/cat/file/downloadFile?url=',
      progressBarPercentage: 0
    }
  },
  watch: {
    screenWeight(val) {
      if (val < 650) {
        this.tableHeight = '260px !important'
        console.log(this.tableHeight)
      } else {
        this.tableHeight = (val * 0.4) + 'px !important'
      }
    }
  },

  mounted() {

    window.onresize = () => {
      return (() => {
        that.screenWeight = document.body.clientWidth;
      })()
    }
    if (this.screenWeight < 650) {
      this.tableHeight = '260px !important'
    } else {
      this.tableHeight = (this.screenWeight * 0.4) + 'px !important'
    }
    downlodePc({
      "type": 4,
      "userId": 2,
      "userType": 2
    }).then(({data}) => {
      console.log(data)
      this.scancode = this.baseUrl + data.object.url
    })
    const that = this

  },
  methods: {

    handleDownLoad() {
      // ajax.downloadFile(this.scancode,null,'文件下载')
      let that = this
      that.showProgress = true
      let nonce = this.getNum()
      let timestamp = new Date().getTime()
      axios.get(this.scancode, {
        responseType: 'blob',
        onDownloadProgress: function (event) {
          let percentage = event.loaded / event.total
          that.progressBarPercentage = (percentage * 100).toFixed(0)
          if (event.loaded === event.total) {
            that.showProgress = false
          }
        },
        headers: {
          time: timestamp,
          nonce: nonce,
          sign: md5(timestamp + nonce),
        }
      }).then(res => {

        const blobUrl = window.URL.createObjectURL(res.data);
        let a = document.createElement("a");
        a.href = blobUrl;
        a.download = '【沃慧管】会员管家-天下医生.exe';
        a.click();
        // 释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      })
    },
    getNum() {
      let num = ''
      for (let i = 0; i < 6; i++) {
        num += Math.floor(Math.random() * 10)
      }
      return num
    },
  }
}
</script>

<style lang='less'>
@media only screen and (max-width: 1920px) {
  .el-carousel__indicator--horizontal {
    padding: 12px 7px !important;
  }

  .el-carousel__indicators--horizontal {
    bottom: 9px !important;
  }

  .el-carousel__button {
    width: 40px !important;
    height: 3px !important;
  }

  .el-carousel--horizontal {
    margin-top: 80px;
  }

  /*.el-carousel__container{*/
  /*  height: 700px !important;*/
  /*}*/
  .el-carousel__container .el-carousel__item img {
    width: 100%;
    height: 100% !important;
  }

  .carousel-box {
    .el-dialog__title {
      font-size: 24px;
      color: #333;
    }

    .el-dialog {
      .el-button {
        width: 80px !important;
      }
    }

    .down-box {
      width: 440px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 60px;
    }

    .down-list {
      text-align: left;
      color: #333;
      font-size: 18px;

      li {
        margin-bottom: 25px;
      }

      a {
        display: inline-block;
        width: 100px;
        height: 30px;
        margin-left: 10px;
        background: #35c6ac;
        border-radius: 2px;
        line-height: 30px;
        text-align: center;
        color: #fff;
      }
    }
  }

  .carouselmain {
    position: absolute;
    top: 35%;
    right: 10%;
    width: 650px;
    margin: auto 0;
    z-index: 11;
    text-align: left;

    h4 {
      color: #fff;
      font-size: 40px;
      font-weight: 500;
    }

    h5 {
      margin-top: 10px;
      font-size: 24px;
      color: #fff;
      font-weight: normal;
    }

    .text {
      margin: 0 0 20px;
      color: #fff;
      font-size: 24px;
      font-weight: 400;
    }

    .PCdownload {
      display: inline-block;
      color: #fff;
      font-size: 20px;
      padding: 15px 20px;
      border-radius: 8px;
      background: #f5a623;

      &.drive-btn {
        background: #35c6ac;
      }

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }

    .PCdownloads {
      display: block;
      margin-top: 10px;
      font-size: 18px;
      color: #fff;
    }

    .text {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
    }

    .read {
      display: inline-block;
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #54c4c5;
      padding-left: 22px;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .el-carousel--horizontal {
    margin-top: 60px;
  }

  /*.el-carousel__container{*/
  /*  height: 500px !important;*/
  /*}*/
  .carouselmain {
    top: 25%;
    right: 10%;
    width: 560px;

    .down-box {
      margin-top: 20px;
    }

    h4 {
      font-size: 35px;
    }

    .text {
      margin: 10px 0 20px;
      font-size: 15px;
    }

    .huawei-img {
      width: 130px;
    }

    .PCdownload {
      font-size: 16px;
      padding: 8px 15px;

      img {
        width: 25px;
        height: 25px;
      }
    }

    .PCdownloads {
      font-size: 16px;
    }
  }
}

@media only screen and (max-width: 992px) {
  .carouselmain {
    top: 15%;
    right: 5%;
    width: 490px;

    .down-box {
      margin-top: 20px;
    }

    h4 {
      font-size: 30px;
    }

    h5 {
      font-size: 20px;
    }

    .text {
      margin: 10px 0 20px;
      font-size: 14px;
    }

    .PCdownload {
      font-size: 16px;
      padding: 10px 15px;

      img {
        width: 25px;
        height: 25px;
        margin-right: 8px;
      }
    }

    .huawei-img {
      width: 130px;
    }

    .PCdownloads {
      font-size: 16px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .el-carousel .el-carousel__container {
    height: 100% !important;
  }

  .el-carousel__indicator--horizontal {
    padding: 4px 2px !important;
  }

  .carouselmain {
    top: calc(50% - 110px);
    right: calc(50% - 170px);
    width: 340px;
    height: 200px;

    .down-box {
      width: 350px;
      margin-top: 10px;
    }

    h4 {
      font-size: 18px;
    }

    h5 {
      font-size: 14px;
    }

    .text {
      margin: 0 0 10px;
      font-size: 14px;
    }

    .PCdownload {
      font-size: 14px;
      padding: 8px 10px;

      &.drive-btn {
        margin-top: 10px;
      }

      img {
        width: 20px;
        height: 20px;
        margin-right: 0;
      }
    }

    .huawei-img {
      width: 100px;
    }

    .PCdownloads,
    .text {
      font-size: 14px;
    }
  }
}

@media only screen and (max-width: 600px) {
}
</style>



// WEBPACK FOOTER //
// src/components/carousel.vue